export default "__VITE_ASSET__BcX7yguk__"